module.exports = __webpack_public_path__ + "static/img/1_0027.c43ab88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0027.jpg
// module id = i2Np
// module chunks = 0